<script setup lang="ts">
import type { SupportedLocale } from '@foodlista/shared/i18n/types'

const route = useRoute()

const { locale } = useI18n()
const termsDescriptions: Partial<Record<SupportedLocale, string>> = {
  en: 'Read the Terms and Conditions for using Foodlista.',
  it: 'Leggi i Termini e Condizioni per l\'utilizzo di Foodlista.',
  fr: 'Consultez les Conditions Générales d\'Utilisation de Foodlista.',
}

const termsDescription = computed(() =>
  termsDescriptions[locale.value as SupportedLocale] ?? termsDescriptions.en,
)

const { data: page } = await useAsyncData(
  () => `legal:${route.path}`,
  async () =>
    (await queryCollection('legal').path(route.path).first())
    ?? (await queryCollection('legal').path('/terms').first()),
)
useSeoMeta({
  title: () => page.value?.title,
  description: () => termsDescription.value,
  ogTitle: () => page.value?.title,
  ogDescription: () => termsDescription.value,
})
</script>

<template>
  <main
    class="prose mx-auto min-h-dvh overflow-y-auto px-8 pb-8 pt-32 dark:prose-invert md:[&_h1]:whitespace-nowrap"
  >
    <ContentRenderer v-if="page" :value="page" />
  </main>
</template>
